import { render, staticRenderFns } from "./TyresTable.vue?vue&type=template&id=acbfb48a&scoped=true"
import script from "./TyresTable.vue?vue&type=script&lang=js"
export * from "./TyresTable.vue?vue&type=script&lang=js"
import style0 from "./TyresTable.vue?vue&type=style&index=0&id=acbfb48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbfb48a",
  null
  
)

export default component.exports